import { useState } from "react";
import { SearchBox, SearchBoxProps } from "react-instantsearch-dom";

import SearchImageButton from "../../public/img/search.svg";

type CustomSearchBoxExtendedComponentProps = {
  onClick?: Function;
} & SearchBoxProps;

function CustomSearchBoxExtendedComponent(
  props: CustomSearchBoxExtendedComponentProps
) {
  // @ts-ignore
  return <SearchBox {...props} />;
}

type CustomSearchBoxProps = {
  showSearchImage?: boolean;
  setShowModalSearch: Function;
};

export default function CustomSearchBox({
  showSearchImage,
  setShowModalSearch,
}: CustomSearchBoxProps) {
  const [showSearchImageButton, setShowSearchImageButton] = useState(true);

  return (
    <CustomSearchBoxExtendedComponent
      className="leading-5 pl-5 pr-3 py-2 border border-transparent bg-gray-100 text-gray-300 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-white focus:ring-white focus:text-gray-900 sm:text-sm rounded-full"
      translations={{ placeholder: "Buscar por título, tema o concepto" }}
      submit={
        <SearchImageButton
          className={`h-5 w-5 text-gray-400 ${
            showSearchImageButton && showSearchImage ? "" : "hidden"
          }`}
        />
      }
      onChange={(event) => {
        const totalCharacters = event.currentTarget.value?.length;
        if (totalCharacters >= 3) setShowModalSearch(true);
        if (totalCharacters < 3) setShowModalSearch(false);
        if (totalCharacters === 0) setShowSearchImageButton(true);
        if (totalCharacters > 0) setShowSearchImageButton(false);
      }}
      onClick={(event) => {
        const totalCharacters = event.currentTarget.value?.length;
        if (totalCharacters >= 3) setShowModalSearch(true);
      }}
      onReset={() => {
        setShowSearchImageButton(true);
        setShowModalSearch(false);
      }}
    />
  );
}
